import React from "react";
import { Card } from "react-bootstrap";
import { Tilt } from "react-tilt";

export default function Services() {
  return (
    <>
      <section className="service">
        <br /><br />
        <div className="container justify-content-center text-center my-5 wow-delayed">
          <h3 className="fw-bold " style={{ color: 'orangered'}}>Services</h3>
          <h1  className="my-3 display-6 fw-bold ">What I Do for Clients</h1>

          <div className="row justify-content-center text-center">
           

            <div className="col-lg-5 col-md-6 col-sm-12 justify-content-center text-center">
              {/* Mobile App Development - Flutter */}
              <Tilt className="tilt-effect" options={{ max: 25 }}>
                <Card className='justify-content-center text-center my-5' style={{ borderRadius: '30px', textAlign: 'left', width: '100%', alignItems: 'center' }}>
                  <div className="row">
                    <div className="col-lg-3 my-5 d-flex justify-content-center">
                      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg" alt="Flutter Logo" width="60" height="80" />
                    </div>
                    <div className="col-lg-9 my-2">
                      <Card.Body style={{ textAlign: 'left' }}>
                        <Card.Title style={{ fontSize: '23px' }}>Mobile App Development</Card.Title>
                        <Card.Text style={{ lineHeight: '30px', fontSize: '15px' }} className='text-secondary my-3'>
                          Building cross-platform mobile apps with Flutter that combine performance, aesthetics, and functionality for an exceptional user experience.
                        </Card.Text>
                      </Card.Body>
                    </div>
                  </div>
                </Card>
              </Tilt>

              {/* UI/UX Design - Figma */}
              <Tilt className="tilt-effect" options={{ max: 25 }}>
                <Card className='justify-content-center text-center my-5' style={{ borderRadius: '30px', textAlign: 'left', width: '100%', alignItems: 'center' }}>
                  <div className="row">
                    <div className="col-lg-3 my-5 d-flex justify-content-center">
                      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" alt="Figma Logo" width="60" height="80" />
                    </div>
                    <div className="col-lg-9 my-2">
                      <Card.Body style={{ textAlign: 'left' }}>
                        <Card.Title style={{ fontSize: '23px' }}>UI/UX Design</Card.Title>
                        <Card.Text style={{ lineHeight: '30px', fontSize: '15px' }} className='text-secondary my-3'>
                          Designing user-centric interfaces in Figma that prioritize usability, accessibility, and visual harmony across all platforms.
                        </Card.Text>
                      </Card.Body>
                    </div>
                  </div>
                </Card>
              </Tilt>
            </div>

            <div className="col-lg-5
             justify-content-center text-center">
              {/* Full Stack Web Development - React (MERN/PERN) */}
              <Tilt className="tilt-effect" options={{ max: 25 }}>
                <Card className='justify-content-center text-center my-5' style={{ borderRadius: '30px', textAlign: 'left', width: '100%', alignItems: 'center' }}>
                  <div className="row">
                    <div className="col-lg-3 my-5 d-flex justify-content-center">
                      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React Logo" width="60" height="80" />
                    </div>
                    <div className="col-lg-9 my-2">
                      <Card.Body style={{ textAlign: 'left' }}>
                        <Card.Title style={{ fontSize: '21px' }}>Full Stack Web Development</Card.Title>
                        <Card.Text style={{ lineHeight: '28px', fontSize: '15px' }} className='text-secondary my-3'>
                          Developing scalable and robust web applications using PERN and MERN stacks, ensuring both frontend and backend efficiency.
                        </Card.Text>
                      </Card.Body>
                    </div>
                  </div>
                </Card>
              </Tilt>

              {/* Content Writing */}
              <Tilt className="tilt-effect" options={{ max: 25 }}>
                <Card className='justify-content-center text-center my-5' style={{ borderRadius: '30px', textAlign: 'left', width: '100%', alignItems: 'center' }}>
                  <div className="row">
                    <div className="col-lg-3 my-5 d-flex justify-content-center">
                      <img src="https://img.icons8.com/external-flat-juicy-fish/80/external-content-writing-content-creation-flat-flat-juicy-fish.png" alt="" width="80" height="80" />
                    </div>
                    <div className="col-lg-9 my-2">
                      <Card.Body style={{ textAlign: 'left' }}>
                        <Card.Title style={{ fontSize: '23px' }}>Content Writing</Card.Title>
                        <Card.Text style={{ lineHeight: '28px', fontSize: '15px' }} className='text-secondary my-3'>
                          Writing clear, persuasive, and SEO-optimized content that connects with your audience 
                        </Card.Text>
                      </Card.Body>
                    </div>
                  </div>
                </Card>
              </Tilt>
            </div>

  
          </div>
        </div>
      </section>
    </>
  );
}
